import { render, staticRenderFns } from "./PF.vue?vue&type=template&id=3be920a6&scoped=true"
import script from "./PF.vue?vue&type=script&lang=js"
export * from "./PF.vue?vue&type=script&lang=js"
import style0 from "./PF.vue?vue&type=style&index=0&id=3be920a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be920a6",
  null
  
)

export default component.exports